import { faRightFromBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import { FAIcon } from './fa-icon';

export const SignOutIcon = ({
  size,
  width,
}: { width?: string } & Omit<FontAwesomeIconProps, 'icon'>) => (
  <FAIcon icon={faRightFromBracket} size={size} width={width} />
);
